module.exports = __webpack_public_path__ + "img/87711f6.png";